import React from "react"
import ReactTable from "react-table"
import classNames from "utils/classNames"
interface CustomReactTableProps {
  [key: string]: any
}

const CustomReactTable = ({
  className,
  leftAlign,
  ...otherProps
}: CustomReactTableProps) => {
  return (
    <ReactTable
      className={classNames(
        "vt-custom-react-table",
        {
          "vt-custom-react-table-text-left": leftAlign,
        },
        className
      )}
      {...otherProps}
      showPaginationBottom={false}
    />
  )
}

export default CustomReactTable
